export const VIEW_ONLY_DISABLED_MESSAGE = 'You have view-only access';
